import { Button } from "react-bootstrap";
import { BoxArrowUpRight } from "react-bootstrap-icons";
import Modal from 'react-bootstrap/Modal';
import DocIcon from "../../assets/images/doc-icon.svg";

interface PropData {
    isShow: any;
    close: any;
    url?: string;
    fileName?: string;
}

const DocumentViewer = (props: PropData) => {
    const onCancel = () => {
        props.close();
    };

    const name = props.fileName || "";
    const isImage = /(\.(jpg|jpeg|png|gif))$/i.test(name);
    const isPdf = /(\.(pdf))$/i.test(name);

    const openInNewTab = () => {
        props.url && window.open(props.url, "_blank");
    };

    return (
        <>
            {
                props.isShow &&
                <Modal show={props.isShow} onHide={onCancel} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="font-16 text-break">{name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        {!props.url && <p className="mb-0 py-5">Loading document...</p>}

                        {props.url && isImage &&
                            <img src={props.url} alt={name} className="w-100" style={{ maxHeight: "70vh", objectFit: "contain" }} />}

                        {props.url && isPdf &&
                            <iframe src={props.url} title={name} width="100%" height="600" style={{ border: "none" }} />}

                        {props.url && !isImage && !isPdf &&
                            <div className="py-5">
                                <img src={DocIcon} width={60} height={60} alt="" />
                                <p className="font-14 text-secondary mt-3 mb-0">
                                    This file type cannot be previewed here. Please open it in a new tab.
                                </p>
                            </div>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn-brand-1" onClick={() => openInNewTab()}>
                            <BoxArrowUpRight size={14} className="me-2" />Open in New Tab
                        </Button>
                        <Button className="btn-brand-1" onClick={() => onCancel()}>Close</Button>
                    </Modal.Footer>
                </Modal>
            }
        </>
    );
};

export default DocumentViewer;
